export default "__VITE_ASSET__ksF0MVTo__"